export const ko = {
  header: { title: "전 세계로 확장하세요. Short당 $2. 어떤 언어든 가능합니다!", subtitle: "🔥결과에 대해서만 지불 – 초당 $0.089에서 $0.009까지🔥" },
  steps: { uploadVideo: "비디오 업로드", selectLanguages: "언어 선택", conversionResult: "변환 및 결과" },
  upload: { dragAndDrop: "비디오 파일을 여기에 드래그 앤 드롭", orClickToSelect: "또는 클릭하여 선택", supportedFormats: "지원 형식: MP4, AVI, MOV, MKV, WebM", maxFileSize: "• 최대 파일 크기: 200 MB", maxDuration: "• 최대 길이: 30초", processingTime: "• 처리 시간은 비디오 해상도에 따라 2~15분", chooseFile: "파일 선택", selectedFile: "선택된 파일:", size: "크기:", fileTypeError: "비디오 파일을 선택해주세요", fileSizeError: "파일 크기({size} MB)가 200 MB 최대 제한을 초과합니다", durationError: "비디오 길이({duration}초)가 30초 최대 제한을 초과합니다", fileReadError: "비디오 파일을 읽을 수 없습니다. 다른 파일을 시도해주세요." },
  languages: { sourceAudioLanguage: "소스 오디오 언어", targetAudioLanguage: "대상 오디오 언어", selectLanguage: "언어 선택..." },
  languageOptions: { ru: "러시아어", en: "영어", es: "스페인어", fr: "프랑스어", de: "독일어", it: "이탈리아어", pt: "포르투갈어", pl: "폴란드어", zh: "중국어", ja: "일본어", ko: "한국어", bg: "불가리아어", hr: "크로아티아어", cs: "체코어", da: "덴마크어", nl: "네덜란드어", et: "에스토니아어", fi: "핀란드어", el: "그리스어", hu: "헝가리어", ga: "아일랜드어", lv: "라트비아어", lt: "리투아니아어", mt: "몰타어", ro: "루마니아어", sk: "슬로바키아어", sl: "슬로베니아어", sv: "스웨덴어" },
  conversion: { replaceAudio: "내 목소리 복제", uploadVideoAndSelectLanguages: "비디오를 업로드하고 언어를 선택해 계속하세요", fixValidationError: "위의 파일 검증 오류를 수정해주세요", createSubtitles: "자막 만들기", uploadVideoForSubtitles: "자막을 만들기 위해 비디오를 업로드하세요", selectTranslationLanguage: "번역 언어 선택" },
  demo: { seeVeviInAction: "VEVI 실제 보기", watchHowItWorks: "우리의 AI 음성 교체 기술이 어떻게 작동하는지 보세요", beforeEnglish: "이전 (영어)", originalPresentation: "원본 기업 프레젠테이션", afterSpanish: "이후 (스페인어,프랑스어,중국어,이탈리아어)", aiTranslatedVoice: "자연스러운 음성으로 AI 번역", demoTitle: "데모 - VEVI 실제" },
  reviews: { title: "고객 후기", subtitle: "전 세계 마케팅 전문가들의 신뢰", customerReviews: [{ name: "사라 존슨", position: "디지털 마케팅 매니저", company: "TechFlow Solutions", text: "VEVI가 우리의 국제 마케팅 캠페인을 변화시켰습니다!" }, { name: "마이클 첸", position: "콘텐츠 마케팅 디렉터", company: "GlobalReach Media", text: "여러 지역의 비디오 콘텐츠를 관리하는 사람으로서 VEVI는 게임 체인저입니다." }, { name: "엠마 로드리게스", position: "브랜드 마케팅 전문가", company: "InnovateCorp", text: "새로운 시장으로 확장하면서 보이스오버 비용에서 수천 달러를 절약했습니다." }, { name: "데이비드 톰슨", position: "마케팅 캠페인 매니저", company: "NextGen Brands", text: "VEVI의 속도와 품질은 비교할 수 없습니다." }, { name: "리사 박", position: "소셜 미디어 마케팅 리드", company: "CreativeEdge Agency", text: "VEVI가 우리 작은 에이전시가 고객에게 다국어 비디오 서비스를 제공할 수 있게 했습니다." }, { name: "제임스 윌슨", position: "퍼포먼스 마케팅 디렉터", company: "ScaleUp Ventures", text: "퍼포먼스 마케팅에서 ROI가 전부이고, VEVI가 그것을 제공합니다." }] },
  payment: { title: "변환 결제", processingCost: "처리 비용", duration: "길이:", baseCost: "기본 비용", discount: "할인 ({promoCode}):", discountAmount: "할인 금액:", total: "총계:", emailToReceiveResult: "결과를 받을 이메일", emailPlaceholder: "your-email@example.com", promoCode: "🎟️ 프로모 코드 (선택사항)", promoCodePlaceholder: "프로모 코드 입력", check: "확인", checking: "확인 중...", addSubtitles: "비디오에 자막 추가", addSubtitlesDescription: "대상 언어로 자막 생성 및 삽입", highQualityTranslation: "• 고품질 AI 번역", originalVideoPreserved: "• 원본 비디오 보존", fastProcessing: "• 빠른 처리 (일반적으로 5-10분)", resultWillBeSent: "• 결과가 지정된 이메일로 전송됩니다", cancel: "취소", continue: "계속", enterEmail: "이메일을 입력해주세요", enterValidEmail: "유효한 이메일 주소를 입력해주세요", enterPromoCode: "프로모 코드를 입력해주세요", invalidPromoCode: "유효하지 않은 프로모 코드", validPromoCode: "유효한 프로모 코드! {discount}% 할인이 적용되었습니다" },
  progress: { title: "비디오 처리 중", uploadingAndExtracting: "🎬 업로드 및 오디오 추출", transcribingAndTranslating: "🗣️ 음성 전사 및 번역", synthesizingAudio: "🎵 새로운 오디오 트랙 합성", step: "단계:", error: "오류" },
  result: { title: "완료! 비디오가 처리되었습니다", conversionCompleted: "변환이 성공적으로 완료되었습니다!", processedVideoDescription: "🎬 음성 복제가 포함된 처리된 비디오", payAndDownload: "결제 및 다운로드", videoNotAvailable: "비디오를 사용할 수 없음", useDownloadButton: "아래 다운로드 버튼을 사용해주세요", downloadError: "다운로드 오류" },
  emailSent: { title: "비디오 전송됨! 🎉", videoOnWay: "비디오가 이미 당신의 이메일로 가는 중입니다 🙏❤️", checkInbox: "받은 편지함과 스팸 폴더를 확인하세요. 처리된 비디오가 곧 도착할 것입니다!", whatsNext: "다음은 무엇인가요?", checkEmail: "• 이메일 확인 ({email})", checkSpam: "• 찾지 못하면 스팸/정크 폴더 확인", downloadAndEnjoy: "• 더빙된 비디오를 다운로드하고 즐기세요!", close: "닫기", processAnotherVideo: "다른 비디오 처리" },
  processingSteps: { uploading: "비디오 업로드 중...", extracting: "오디오 추출 중...", transcribing: "음성 전사 중...", translating: "콘텐츠 번역 중...", synthesizing: "새로운 음성 합성 중...", rendering: "최종 비디오 렌더링 중...", complete: "처리 완료!" },
  common: { minutes: "분", seconds: "초", loading: "로딩 중...", error: "오류", success: "성공" },
  socialMedia: {
    title: "연결 유지",
    description: "AI 음성 기술의 최신 정보 받기"
  },

  // Services (for Footer)
  services: {
    dubbing: "더빙",
    voiceClone: "음성 복제 더빙",
    newVoice: "새로운 음성 더빙",
    multilingual: "다국어 더빙",
    multiSpeaker: "다중 화자 더빙",
    subtitles: "자막",
    subtitlesOnly: "자막만",
    multilingualSubtitles: "다국어 자막",
    subtitlesDescription: "모든 플랫폼을 위한 정확한 자막을 자동으로 생성합니다.",
    subtitlesPrice: "처리 비용: $0.01/초",
    addSubtitles: "자막 추가",
    needsTranslation: "번역이 필요하신가요?",
    translationLanguage: "번역 언어"
  },

  // Footer
  footer: {
    legal: "법적 정보",
    privacyPolicy: "개인정보 처리방침",
    termsOfUse: "이용 약관"
  },

  // Navigation
  nav: {
    blog: "블로그"
  },

  // Blog (using English content as fallback)
  blog: {
    title: "VEVI Monster 블로그",
    subtitle: "VEVI 우주의 역사와 신화",
    readMore: "더 읽기",
    backToBlog: "블로그로 돌아가기",
    articleNotFound: "기사를 찾을 수 없습니다",
    characteristics: "특성",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "Vevi는 Zera-13b의 플라즈마 소용돌이에서 태어난 존재입니다. 그는 살도 금속도 아닙니다—그의 몸은 전자기장에 의해 함께 유지되는 진동하는 입자로 구성됩니다.",
        metadata: {
          "은하": "MoM-z14",
          "나이": "134억 년",
          "유형": "메탄과 네온의 밀한 대기를 가진 암석 행성",
          "별": "빨간 원시별 Zera-13",
          "궤도": "시스템의 두 번째 행성",
        },
        content: [
          "🌑 설명",
          "Zera-13b는 우주가 빛나기 시작한 시대에 태어난 고대의 거의 잊혀진 세계입니다.",
          "그 하늘은 희미한 녹색 불꽃으로 반짝이고, 밀한 대기는 네온 폭풍으로 떨립니다. 표면은 메탄 바람이 공기 중에 불의 흔적을 남기는 유리 같은 분화구로 덮인 검은 회색 풍경입니다.",
          "표면 아래에는 전설에 따르면 사고할 수 있는 첫 번째 형태의 에너지가 태어난 얼어붙은 가스 동굴이 있습니다.",
          "👾 Vevi (Vevi Monster)",
          "Vevi는 Zera-13b의 플라즈마 소용돌이에서 태어난 존재입니다.",
          "그는 살도 금속도 아닙니다—그의 몸은 전자기장에 의해 함께 유지되는 진동하는 입자로 구성됩니다.",
          "그의 눈은 별 Zera-13의 반사된 빛으로 빛나고, 그의 목소리는 네온 바람의 속삭임처럼 들립니다.",
          "Vevi는 원시별이 사라지기 시작했을 때 그의 세계를 떠났습니다. 그는 새로운 에너지를 찾는 본능에 이끌려 은하계 간 공허를 여행했습니다.",
          "이제 그는 세계를 떠돌며 Zera-13b의 원시 빛의 입자를 가지고 다닙니다.",
          "빛은 행성에서 왔습니다",
          "그에게는 다리가 없습니다—행성에 엄청난 중력이 있고 그는 단순히 공중에 떠 있기 때문입니다",
          "그는 돌고래, 고래, 범고래의 음파와 유사한 방식으로 소통합니다 (또는 소리를 냅니다).",
          "그의 언어는 UFOnic라고 불립니다",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Sub는 높은 물질 밀도를 가진 우주의 희귀한 지역인 Sub Zone에서 태어난 초기 우주의 존재입니다.",
        metadata: {
          "객체 이름": "Sub Zone (SUB-Z)",
          "객체 유형": "원시 클러스터 / 은하 형성 지역",
          "시대": "빅뱅 후 약 2~3억 년",
          "적색 편이": "z ≈ 14–15",
          "적경 (RA)": "02h 17m 43s",
          "적위 (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Baddy Sub 데이터",
          "하단에 두 개의 하지와 상단에 확장된 형태의 세 개의 눈을 가진 길고 얇은 타원형 몸체",
          "그에게는 입이 없습니다.",
          "팔로 해석될 수 있는 두 개의 상부 얇은 사지도 있습니다.",
          "각 사지에 두 개의 손가락.",
          "전체 몸체는 나무 가지를 닮았습니다",
          "피부는 매끄러운 매트 구조를 가지고 있습니다",
          "색상은 녹갈색 (색소 침착)입니다",
          "카멜레온처럼 환경에 따라 색상을 변경할 수 있습니다.",
          "Baddy Sub가 태어난 행성의 설명:",
          "Sub Zone은 첫 번째 은하 구조가 형성되기 시작한 높은 물질 밀도를 가진 초기 우주의 희귀한 지역입니다. 관측은 원시 가스, 복사 및 중력파의 강한 상호작용을 나타냅니다. 이 지역은 전형적인 원시 은하 지역에는 특징적이지 않은 불안정한 신호 패턴과 비정상적인 공명 활동을 기록했습니다.",
          "과학적 중요성:",
          "Sub Zone은 은하 조립의 초기 단계, 젊은 우주에서의 신호 전파, 그리고 혼란스러운 복사장에서 구조화된 우주 시스템으로의 전환을 연구하는 핵심 객체로 간주됩니다.",
          "상태:",
          "해결되지 않은 형성 지역으로 분류됩니다. 추가 연구가 필요합니다.",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "자주 묻는 질문",
    subtitle: "VEVI에 대해 알아야 할 모든 것",
    questions: [
      {
        question: "음성만 작업하나요?",
        answer: "예 — 자연스럽고 진정성 있게 유지하면서 다른 언어로 들리도록 음성을 교체합니다."
      },
      {
        question: "결제는 전에 하나요 후에 하나요?",
        answer: "후에. 먼저 결과를 듣고 나서 결제합니다."
      },
      {
        question: "환불은?",
        answer: "필요 없습니다 — 결과에 만족할 때만 결제합니다."
      },
      {
        question: "10분보다 긴 비디오는?",
        answer: "문제 없습니다. 온라인 채팅에서 AI 어시스턴트에게 지침을 물어보세요."
      },
      {
        question: "다른 음성을 선택할 수 있나요?",
        answer: "아니요 — 자신의 음성만 복제합니다."
      },
      {
        question: "최소 결제액은?",
        answer: "$0.50부터."
      },
      {
        question: "비디오는 어떻게 받나요?",
        answer: "브라우저에서 즉시 다운로드 + 결제 후 이메일로 복사본 전송."
      },
      {
        question: "대량 주문 할인은?",
        answer: "예 — 온라인 채팅에서 AI 어시스턴트에게 문의하세요."
      },
      {
        question: "답변을 찾지 못하셨나요?",
        answer: "온라인 채팅에서 AI 어시스턴트에게 물어보세요 — 도와드리겠습니다."
      },
      {
        question: "지원되지 않는 형식은?",
        answer: "변환기를 사용하거나 온라인 채팅의 AI 어시스턴트에게서 빠른 도움을 받으세요."
      },
      {
        question: "내 비디오에는 올바르게 발음해야 하는 특정 용어가 포함되어 있습니다. 제어할 수 있나요?",
        answer: "예 — 온라인 채팅에서 AI 어시스턴트에게 메시지를 보내기만 하면, 특정 용어를 표시하거나 보존하는 방법(예: 영어로 남겨두기)에 대한 지침을 보내드립니다."
      },
      {
        question: "이메일을 받지 못했습니다. 어떻게 해야 하나요?",
        answer: "처리 시간은 대기열 볼륨으로 인해 다를 수 있습니다. 걱정하지 마세요 — 파일은 안전합니다. 준비되면 알림 또는 직접 다운로드 링크를 받게 됩니다."
      }
    ]
  }
};
